export function deepContains<T1, T2>(
  obj: T1,
  subset: T2,
  excludedFields: (keyof T1 | keyof T2 | any)[] = [],
): boolean {
  // undefined subset means no constraints — always contained
  if (subset === undefined) {
    return true;
  }

  // Both are equal
  if (subset === obj) {
    return true;
  }

  if (
    subset === null ||
    obj === null ||
    typeof subset !== 'object' ||
    typeof obj !== 'object' ||
    Array.isArray(subset) !== Array.isArray(obj)
  ) {
    return false;
  }

  // Handle Date objects
  if (subset instanceof Date && obj instanceof Date) {
    return subset.getTime() === obj.getTime();
  }

  // Handle Arrays
  if (Array.isArray(subset) && Array.isArray(obj)) {
    if (subset.length > obj.length) {
      return false;
    }

    for (let i = 0; i < subset.length; i++) {
      if (!deepContains(obj[i], subset[i], excludedFields)) {
        return false;
      }
    }
    return true;
  }

  // Check that all keys in subset exist in obj and match
  for (const key of Object.keys(subset)) {
    if (excludedFields.includes(key)) {
      continue;
    }

    if (!(key in obj)) {
      return false;
    }

    // @ts-expect-error
    if (!deepContains(obj[key], subset[key], excludedFields)) {
      return false;
    }
  }

  return true;
}
